import { EMPLOYEE_LISTING_ITEMS_PER_PAGE_LIST } from './employee-list.facade';
import { TEmployeeListActions } from './employee-list.actions';
import { TEmployeeListInfoActionType, TEmployeeListState } from './employee-list.models';

export const initialState: TEmployeeListState = {
  employeeListingInfo: null,
  teamListingInfo: null,
  userPaginationOption: {
    pageNo: 1,
    pageSize: EMPLOYEE_LISTING_ITEMS_PER_PAGE_LIST[0],
  },
};
export function employeeListReducer(state = initialState, action: TEmployeeListActions): TEmployeeListState {
  switch (action.type) {
    case TEmployeeListInfoActionType.GetEmployeeListSuccess:
      return {
        ...state,
        employeeListingInfo: action.employeeListRes,
      };
    case TEmployeeListInfoActionType.GetTeamListSuccess:
      return {
        ...state,
        teamListingInfo: action.teamListRes,
      };
    case TEmployeeListInfoActionType.SetUserPaginationOption:
      return {
        ...state,
        userPaginationOption: action.userPaginationOption,
      };
    default:
      return state;
  }
}
